import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/jobs/constants';

import { jobsQueryKeys } from './queryKeys';

/**
 * What another round of the job's search would add, and how much of the workspace's sourcing allowance is left. Read
 * fresh each time it's enabled: rounds on other jobs use the same allowance.
 */
export const useSourcingAllowanceQuery = (
  jobId: string,
  options: { enabled: boolean },
) =>
  useQuery({
    queryKey: jobsQueryKeys.sourcingAllowance(jobId),
    queryFn: async () => {
      const { data } = await fetchClient.GET(endpoints.jobSourcingAllowance, {
        params: { path: { jobId } },
      });
      return data;
    },
    staleTime: 0,
    ...options,
  });
